import store from '@/store';
import BillingMessageBox from './common/message-box';
import { translation } from '@/plugins/i18n';

export default (reason) => {
  store.commit('setGlobalErrorState', true);
  BillingMessageBox.alert(reason || '', translation('billing.delta.not_eligible_for_offer'), {
    dangerouslyUseHTMLString: true,
    confirmButtonText: translation('billing.success.confirmation.view_my_plan'),
    beforeClose: (action) => {
      if (action === 'confirm') {
        window.location.href = '/billing';
      }
      Promise.reject();
    },
  });
};
